/**
 * Product identity (Rosby) for customer-visible text (Omnyqra/sim#41, Omnyqra/sim#113),
 * see FORK.md.
 *
 * Plain constants without env reads, so blocks, tools, triggers, the executor
 * and server code can import them alike. Surfaces that already read
 * `getBrandConfig().name` keep doing so; both resolve to the same default.
 */
import { defaultBrandConfig } from '@/lib/branding/defaults'

/** Product name shown to customers and third parties. */
export const BRAND_NAME = defaultBrandConfig.name

/** Public homepage, used as contact URL in User-Agent and Referer headers. */
export const BRAND_HOMEPAGE = 'https://rosby.ai'

/** Contact for vulnerability reports (`security.txt`). */
export const SECURITY_EMAIL = 'security@rosby.ai'

/** Default User-Agent for outbound requests made on a customer's behalf. */
export const BRAND_USER_AGENT = `${BRAND_NAME}/1.0 (+${BRAND_HOMEPAGE})`
